import React from 'react';

import { Flex } from '@mantine/core';
import { DataNotFoundAlert } from 'components/DataNotFoundAlert';
import { CalendlyButton } from 'components/SmartAssistantComponents/CalendlyButton';
import { ChatConversationView } from 'components/SmartAssistantComponents/ChatConversationView';
import { useChatMessageHandling } from 'hooks/use-chat-message-handling';
import { useSmartAssistantVisualConfigExtractor } from 'hooks/use-smart-assistant-theme-extractor';
import { SmartAssistant, SmartAssistantType } from 'shared/interfaces/SmartAssistant';

interface SmartAssistantPageProps {
  smartAssistant: SmartAssistant;
  chatHandling: ReturnType<typeof useChatMessageHandling>;
}

export function SmartAssistantPlayground({ smartAssistant, chatHandling }: SmartAssistantPageProps) {
  const {
    messages,
    sendMessage,
    isStreamingResponse,
    forceToolInvocation,
    activeConversation,
    addNewMessageToConversation
  } = chatHandling;

  const smartAssistantVisualConfig = useSmartAssistantVisualConfigExtractor({ avatarUrl: smartAssistant.avatarUrl });

  if (smartAssistant.type === SmartAssistantType.PHONE) return <DataNotFoundAlert />;

  return (
    <Flex
      direction="column"
      w="100%"
      h="100%"
      style={{
        flex: 1,
        minHeight: 0,
        overflow: 'hidden'
      }}
      bg={smartAssistant.secondaryBackgroundColor}>
      <ChatConversationView
        w="100%"
        style={{ flex: 1, minHeight: 0 }}
        messages={messages}
        m={0}
        onSend={sendMessage}
        conversationId={activeConversation.id}
        smartAssistantVisualConfig={smartAssistantVisualConfig}
        smartAssistantId={smartAssistant._id}
        toolConfigs={smartAssistant?.toolConfigs}
        isStreamingResponse={isStreamingResponse}
        forceToolInvocation={forceToolInvocation}
        addNewMessageToConversation={addNewMessageToConversation}
        chatAttachmentConfiguration={smartAssistant.chatAttachmentConfiguration}
        hideMargins
        inputTopSection={
          <Flex direction="row" align="center">
            <CalendlyButton
              toolConfigs={smartAssistant?.toolConfigs}
              smartAssistantVisualConfig={smartAssistantVisualConfig}
            />
          </Flex>
        }
      />
    </Flex>
  );
}
